<template>
	<div class="offical-container"
		@click="$router.push({path: '/work-details',query: {id:data.id,userId: data.user_id}})">
		<img class="bestIcon" src="../assets/Home/best.png" v-if="data.shuxing && data.shuxing == '精品图'" />
		<div class="likeNum">
			<img class="likeNumIcon" src="../assets/WorkDetails/iconL.png" />
			<span>{{data.zan_count}}</span>
		</div>
		<img class="likeIcon" :src="data.img" />
		<div class="likeTitle ellipsis-1">{{data.title}}</div>
		<div class="likeDesc ellipsis-2">
			{{data.content}}
		</div>
		<div class="tips">
			<div class="tip">
				{{data.cid}}
			</div>
			<div class="tip" v-for="(item,index) in data.yongtu" :key="index">
				{{item}}
			</div>
		</div>
		<div class="buyNow" v-if="showBuy">
			￥{{data.price ? data.price : '0'}} 立即购买
		</div>
	</div>
</template>
<script>
	export default {
		name: 'OfficalItem',
		props: {
			data: {
				type: Object,
				default: () => {}
			},
			showBuy: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {

			}
		}
	}
</script>

<style lang="scss" scoped>
	.offical-container {
		margin-top: .32rem;
		display: flex;
		flex-direction: column;
		margin-right: .24rem;
		position: relative;
		cursor: pointer;

		.bestIcon {
			position: absolute;
			top: 0;
			left: 0;
			width: .67rem;
			height: .67rem;
		}

		.likeNum {
			position: absolute;
			top: .16rem;
			right: .16rem;
			height: .24rem;
			display: flex;
			align-items: center;
			padding: 0 .1rem;
			background: rgba(255, 255, 255, .9);
			box-shadow: 0px 2px 15px 0px rgba(176, 176, 176, 0.6);
			border-radius: 12px;
			font-weight: 500;
			font-size: .14rem;
			color: #333333;

			.likeNumIcon {
				margin-right: .02rem;
				width: .15rem;
				height: .14rem;
			}

			span {
				margin-top: .02rem;
			}
		}

		.likeIcon {
			width: 2.82rem;
			height: 3.72rem;
			object-fit: cover;
			overflow: hidden;
		}

		.likeTitle {
			width: 2.82rem;
			margin-top: .32rem;
			font-weight: 600;
			font-size: .24rem;
			color: #000000;
			line-height: .32rem;
		}

		.likeDesc {
			height: .4rem;
			width: 2.82rem;
			margin-top: .1rem;
			font-weight: 400;
			font-size: .14rem;
			color: #333333;
			line-height: .2rem;
		}

		.tips {
			margin-top: .16rem;
			display: flex;
			align-items: center;

			.tip {
				height: .26rem;
				margin-right: .12rem;
				padding: .04rem .08rem;
				font-weight: 400;
				font-size: .12rem;
				color: #A88653;
				border-radius: .13rem;
				border: .01rem solid #A88653;
			}
		}

		.buyNow {
			margin: .24rem auto 0;
			width: 2.60rem;
			height: .52rem;
			background: #E29358;
			border-radius: .06rem;
			font-weight: 500;
			font-size: .15rem;
			color: #252525;
			line-height: .52rem;
			text-align: center;
		}
	}
</style>